/*
 * Copyright (C) [2025] [Netzint GmbH]
 * All rights reserved.
 *
 * This software is dual-licensed under the terms of:
 *
 * 1. The GNU Affero General Public License (AGPL-3.0-or-later), as published by the Free Software Foundation.
 *    You may use, modify and distribute this software under the terms of the AGPL, provided that you comply with its conditions.
 *
 *    A copy of the license can be found at: https://www.gnu.org/licenses/agpl-3.0.html
 *
 * OR
 *
 * 2. A commercial license agreement with Netzint GmbH. Licensees holding a valid commercial license from Netzint GmbH
 *    may use this software in accordance with the terms contained in such written agreement, without the obligations imposed by the AGPL.
 *
 * If you are uncertain which license applies to your use case, please contact us at info@netzint.de for clarification.
 */

import { motion } from 'framer-motion';
import cn from '../utils/cn';

interface HorizontalLoaderProps {
  className?: string;
  transitionDurationMS?: number;
  height?: string;
  width?: string;
  barWidth?: string;
  barColor?: string;
  backgroundColor?: string;
}

const HorizontalLoader = ({
  className,
  transitionDurationMS = 4000,
  height = 'h-1',
  width = 'w-full',
  barWidth = 'w-1/2',
  barColor = 'bg-primary',
  backgroundColor = 'bg-accent',
}: HorizontalLoaderProps) => (
  <div className={cn('relative overflow-hidden rounded-lg', height, width, backgroundColor, className)}>
    <motion.span
      className={cn('absolute bottom-0 left-0 top-0', barWidth, barColor)}
      animate={{ x: ['0%', '100%', '0%'] }}
      transition={{
        duration: transitionDurationMS / 1000,
        repeat: Infinity,
        ease: 'easeInOut',
      }}
    />
  </div>
);

export default HorizontalLoader;
export type { HorizontalLoaderProps };
